import { io } from "socket.io-client";

const teacherId = localStorage.getItem("teacherId") || "";

const URL = "https://core.pluritongues.com";

export const socket = io(`${URL}/messages?userId=${teacherId}`, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  secure: URL.startsWith("https"),
  autoConnect: true,
});
